import { USERS_ADD_SUCCESS, USERS_FETCH, USERS_FETCH_ERROR, USERS_FETCH_SUCCESS, USER_ROLES_FETCH_SUCCESS, USER_APPROVER_ROLES_FETCH_SUCCESS, USERS_SELECT_USER, USER_FETCH_DETAILS, USER_FETCH_DETAILS_ERROR, USER_FETCH_DETAILS_SUCCESS, USER_SAVE_DETAILS, USER_SAVE_DETAILS_ERROR, USER_SAVE_DETAILS_SUCCESS, USERS_DELETE_SUCCESS } from "../reduxActions/Types";
import _ from 'lodash';

const INITIAL_STATE = {
  users: null,
  usersFetchError: null,
  fetchingUsers: false,
  fetchingUserDetails: false,
  userDetailsFetchError: null,
  selectedUser: null,
  selectedUserDetails: null,
  savingUserDetails: false,
  savingUserDetailsError: null
};

const UsersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERS_ADD_SUCCESS:
      const addedUser = { ...action.payload, id: action.payload.userId };
      const users = state.users
        ? [addedUser, ...state.users]
        : [addedUser];

      return {
        ...state,
        users,
        selectedUserDetails: addedUser,
        selectedUser: addedUser
      };
    case USER_SAVE_DETAILS:
      return {
        ...state,
        savingUserDetails: true,
        savingUserDetailsError: null
      };
    case USER_SAVE_DETAILS_ERROR:
      return {
        ...state,
        savingUserDetails: false,
        savingUserDetailsError: action.payload
      };
    case USER_SAVE_DETAILS_SUCCESS:
      return {
        ...state,
        savingUserDetails: false,
        selectedUserDetails: action.payload
      };
    case USER_FETCH_DETAILS:
      return {
        ...state,
        fetchingUserDetails: true,
        userDetailsFetchError: null
      };
    case USER_FETCH_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingUserDetails: false,
        selectedUserDetails: action.payload
      };
    case USER_FETCH_DETAILS_ERROR:
      return {
        ...state,
        fetchingUserDetails: false,
        userDetailsFetchError: action.payload
      };
    case USERS_SELECT_USER:
      return {
        ...state,
        selectedUser: action.payload,
        selectedUserDetails: null
      };
    case USERS_FETCH:
      return {
        ...state,
        fetchingUsers: true,
        usersFetchError: false
      };
    case USERS_FETCH_SUCCESS:
      return {
        ...state,
        users: action.payload,
        fetchingUsers: false
      };
    case USER_ROLES_FETCH_SUCCESS:
      return {
        ...state,
        usersRole: action.payload,
        fetchingUsers: false
      };
    case USER_APPROVER_ROLES_FETCH_SUCCESS:
      return {
        ...state,
        usersApprovalRole: action.payload,
        fetchingUsers: false
      };
    case USERS_FETCH_ERROR:
      return {
        ...state,
        fetchingUsers: false,
        usersFetchError: action.payload
      };
    case USERS_DELETE_SUCCESS:

      const updatedUsers = action.payload.didDelete ? _.pullAllBy(state.users, [{ 'id': action.payload.userId }], 'id') : [...state.users];
      return {
        ...state,
        users: updatedUsers,
        selectedUser: null,
        selectedUserDetails: null
      };


    default:
      return state;
    case 'RESET_ALL_REDUX_STATE':     
    return INITIAL_STATE; }
};
export default UsersReducer;
